<template>
  <div>
    <p v-html="preamble"></p>
    <slot></slot>
    <v-text-field
      label="Type your fullname to esign"
      prepend-inner-icon="mdi-signature"
      :value="value"
      @input="$emit('input', $event)"
    ></v-text-field>
    <v-checkbox
      :label="acceptText"
      :value="accepted"
      :input-value="accepted"
      @change="$emit('update:accepted', $event)"
      true-value="y"
      false-value="n"
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  name: 'ESignature',
  props: {
    value: {
      type: String,
    },
    accepted: {
      type: String,
    },
    preamble: {
      type: String,
      default: 'By typing your name below you consent to using an esignature to digitally sign this document.',
    },
    acceptText: {
      type: String,
      default: 'I agree to digitally sign this document with my esignature.',
    },
  },
};
</script>
